import adminApiClient from "@/lib/api/admin-api-client";
import { env } from "@/config/env";

export interface AdminResetPasswordRequest {
  token: string;
  password: string;
}

export interface AdminResetPasswordResponse {
  message: string;
}

export async function confirmAdminPasswordReset(
  payload: AdminResetPasswordRequest,
) {
  const { data } = await adminApiClient.post<AdminResetPasswordResponse>(
    env.adminAuthResetPasswordPath,
    payload,
  );
  return data;
}
